import { calculateBoxSizes } from './algorithms/calculateBoxSize';
/**
 * https://drafts.csswg.org/resize-observer-1/#resize-observer-entry-interface
 */
var ResizeObserverEntry = /** @class */ (function () {
    function ResizeObserverEntry(target) {
        var boxes = calculateBoxSizes(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = [boxes.borderBoxSize];
        this.contentBoxSize = [boxes.contentBoxSize];
        this.devicePixelContentBoxSize = [boxes.devicePixelContentBoxSize];
    }
    return ResizeObserverEntry;
}());
export { ResizeObserverEntry };
